<template>
    <auto-complete-search @hasSelected="handleSelectedItem" :show-result="showResult" :handler="handleSearch"
                          :result="result"></auto-complete-search>
</template>

<script>
  import AutoCompleteSearch from './../AutoComplete/AutoCompleteSearch';
  import {get} from '@/api';

  export default {
    props: {
      fields: {
        type: String,
        default: '*'
      },

      filters: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        result: [],
        showResult: false,
        selectedItem: null
      };
    },

    components: {
      AutoCompleteSearch
    },

    methods: {
      /**
       * Handle Search.
       */
      handleSearch: window._.debounce(function (val) {
        this.result = [];

        if (val) {
          const fields = 'name,id';

          get(`/medicine?wildcard[]=name,like,${val}&fields=${fields}`).then(res => {
            window._.each(res.data.data, (item) => {
              this.result.push({
                value: `${item.name}`,
                key: item.id
              });
            });

            this.showResult = true;
          });
        }

      }, 300),

      /**
       * Handle selected item.
       *
       * @param item
       */
      handleSelectedItem(item) {
        this.selectedItem = item;

        this.$emit('selected', item);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Common/Medicine/SearchMedicineAutoComplete.vue